let _ = t => t,
  _t;
import { memo, useContext, useMemo } from 'react';
import { shouldShowRecordingClip } from '../../../utils/mediaTimelineUtils';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import styledWithTheme from 'foundations-theming/utils';
import { MediaTimelineHighlight } from './MediaTimelineHighlight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledClipLineContainer = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  top: 0;
  left: ${0}%;
  height: 100%;
  width: 0;
  padding: 0 3px;
  cursor: pointer;
  user-select: none;
  border-left: 1px dashed;
  border-color: ${0};
  transition: 0.1s;
`), ({
  position
}) => position, ({
  theme
}) => theme.color['border-core-default']);
const MediaTimelineClipHighlight = () => {
  const {
    preciseDuration,
    clipEndTime,
    clipStartTime
  } = useContext(MediaPlaybackControlsContext);
  const shouldShow = useMemo(() => shouldShowRecordingClip(clipStartTime, clipEndTime, preciseDuration), [clipStartTime, clipEndTime, preciseDuration]);
  const clipStartPositionPercent = clipStartTime / preciseDuration * 100;
  const clipEndPositionPercent = clipEndTime ? preciseDuration - clipEndTime < 1 ? 100 : clipEndTime / preciseDuration * 100 : 100;
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "mediaTimeline-clipHighlightContainer",
    children: [/*#__PURE__*/_jsx(MediaTimelineHighlight, {
      "data-test-id": "mediaTimeline-clipHighlight",
      startPosition: Math.max(clipStartPositionPercent, 0),
      endPosition: Math.min(clipEndPositionPercent, 100)
    }), /*#__PURE__*/_jsx(StyledClipLineContainer, {
      position: clipStartPositionPercent,
      "data-test-id": "mediaTimeline-clipStartLine"
    }), /*#__PURE__*/_jsx(StyledClipLineContainer, {
      position: clipEndPositionPercent,
      "data-test-id": "mediaTimeline-clipEndLine"
    })]
  });
};
export default /*#__PURE__*/memo(MediaTimelineClipHighlight);